import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import { TrendingUp, TrendingDown } from "lucide-react";

function fmtIndex(n) {
  return new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
}

export default function MarketTicker() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    const fetchIt = () => api.get("/market/indices").then((r) => alive && setData(r.data)).catch(() => {});
    fetchIt();
    const id = setInterval(fetchIt, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!data) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-wrap items-center gap-3"
      data-testid="market-ticker"
    >
      {data.indices.map((ix) => {
        const up = ix.change >= 0;
        return (
          <div
            key={ix.symbol}
            data-testid={`index-${ix.name.replace(/\s/g, "-").toLowerCase()}`}
            className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 soft-shadow"
          >
            <div className="flex items-center gap-1.5">
              <span className={`h-2 w-2 rounded-full ${data.live ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`} />
              <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{ix.name}</span>
            </div>
            <span className="font-mono font-bold text-slate-900">{fmtIndex(ix.price)}</span>
            <span className={`flex items-center gap-1 text-xs font-semibold ${up ? "text-emerald-600" : "text-red-500"}`}>
              {up ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
              {up ? "+" : ""}{fmtIndex(ix.change)} ({up ? "+" : ""}{ix.change_pct}%)
            </span>
          </div>
        );
      })}
      <span className="text-[11px] text-slate-400">
        {data.live ? "Live · NSE/BSE" : "Indicative"}
      </span>
    </motion.div>
  );
}
